module.exports = __webpack_public_path__ + "static/media/Bettkissen_80x60_rueckseite.9a4f2263.png";